import { axios } from "@nuskin/axios-util";
import { RunConfigService, ConfigService } from "@nuskin/ns-util";

export default {
  isEmailVerified: isEmailVerified,
  getRedirectUrl: getRedirectUrl,
};

const http = axios.create();

/**
 * Get Client ID
 *
 * @return {String} The code id, e.g. {'string'}
 */
function getClientID() {
  const marketConfig = ConfigService.getMarketConfig();
  return marketConfig.checkout.clientId;
}

/**
 * Get Client ID
 *
 * @return {String} The code id, e.g. {'string'}
 */
function getRedirectUrl() {
  const config = RunConfigService.getRunConfig();
  const lan = config.language;
  const market = config.country;
  if (market === "JP") return `/markets/${lan}_${market}/profile.html`;

  return `${config.baseUrl}/content/nuskin/${lan}_${market}/profile.html`;
}

/**
 * get Boolean for checking Email Verified
 *
 * @return  {Boolean} , e.g. {true}
 */
async function isEmailVerified(email) {
  let isEmailVerified = false;

  const baseurl = process.env.VUE_APP_EMAIL_API;
  let url = `${baseurl}/emailInfo?email=${email}`;
  try {
    let response = await http.get(url, {
      headers: { client_id: getClientID() },
    });
    isEmailVerified = response.data.data.isVerified;
  } catch (e) {
    console.error(e, "Error checking email verification");
  }

  return isEmailVerified;
}
